var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentOnBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "recentOn",
    d: "M10.074 10.122h1.995a1 1 0 0 1 0 2H9.073a1 1 0 0 1-.998-1.05l-.001-.041v-4a1 1 0 1 1 2 0v3.091zM2.023 4.21a9.992 9.992 0 0 1 8.05-4.067c5.524 0 10 4.477 10 10s-4.476 10-10 10c-5.523 0-10-4.477-10-10h2a8 8 0 0 0 8 8 8 8 0 0 0 8-8A8 8 0 0 0 3.45 5.655l1.34 1.358a.5.5 0 0 1-.355.851H.5a.5.5 0 0 1-.5-.5V3.378a.5.5 0 0 1 .856-.351l1.167 1.182z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#recentOn"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentOnBlue);
export default __webpack_public_path__ + "static/media/recent-on-blue.7dcc2909.svg";
export { ForwardRef as ReactComponent };